/**
 * Copyright (c) 2016 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

// es5 build works with mocha and node 12, when we move to node 14 we can update this
const pdfjs = require('pdfjs-dist/es5/build/pdf');
pdfjs.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/es5/build/pdf.worker.entry.js');

const MIN_SCALE = 0.5;

class PdfService {
  static renderPages(pdfArrayBuffer, viewer, requestedPage = 1, allInOne = true, isPreview = false) {
    const ratio = isPreview ? 100 : 80;
    try {
      pdfjs.getDocument({ data: pdfArrayBuffer, disableFontFace: isPreview ? true : false }).promise.then((pdf) => {
        if (requestedPage > pdf.numPages || requestedPage <= 0) {
          return;
        }
        return pdf.getPage(requestedPage).then((page) => {
          let canvasWidth = (viewer.clientWidth * ratio) / 100;
          let defaultScale = 1,
            scale = 1;
          let defaultWidth = page.getViewport({ scale: defaultScale }).width;
          let initDiff = canvasWidth - defaultWidth;

          if (initDiff < 0) {
            initDiff = initDiff * -1;
          }

          let percentageScale = 0;
          if (canvasWidth !== 0) {
            percentageScale = Math.trunc(initDiff / (canvasWidth / 100)) / 100;
          }

          if (canvasWidth - defaultWidth < 0) {
            scale = defaultScale - percentageScale;
          } else {
            scale = initDiff / defaultWidth + defaultScale;
          }
          scale = Math.max(scale, MIN_SCALE);
          viewer.innerHTML = '';

          if (allInOne) {
            for (let num = 1; num <= pdf.numPages; num++) {
              pdf.getPage(num).then((p) => PdfService.renderPage(p, viewer, scale));
            }
          } else {
            PdfService.renderPage(page, viewer, scale);
          }
        });
      });
    } catch (e) {
      console.log('error getting pdf content(1)', e);
    }
  }

  static renderPage(page, container, scale) {
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement('canvas');
    canvas.setAttribute('class', 'pdf-page');
    const context = canvas.getContext('2d');
    let resolution = window.devicePixelRatio || 3;
    canvas.height = resolution * viewport.height;
    canvas.width = resolution * viewport.width;

    canvas.style.height = viewport.height + 'px';
    canvas.style.width = viewport.width + 'px';

    const renderContext = {
      canvasContext: context,
      viewport: viewport,
      transform: [resolution, 0, 0, resolution, 0, 0]
    };
    container.appendChild(canvas);
    const pdfPageSeparator = document.createElement('div');
    pdfPageSeparator.setAttribute('class', 'pdf-page-separator');
    container.appendChild(pdfPageSeparator);

    page.render(renderContext);
  }

  static getTotalPages(pdf) {
    return pdf && pdf.numPages;
  }

  static getPdfDocument(pdfArrayBuffer) {
    try {
      return new Promise((resolve, reject) => {
        try {
          pdfjs.getDocument(pdfArrayBuffer).promise.then(resolve);
        } catch (e) {
          reject(e);
        }
      });
    } catch (e) {
      console.log('error getting pdf content(2)', e);
    }
  }
}

export default PdfService;
